<template>
  <div class="footer" :class="nftLayoutClass">
    <p class="disclaimer" v-if="disclaimer && disclaimer.show" v-html="disclaimer.message"></p>
    <p>
      <span>
        <a
          href="https://banxa.com/legal-compliance/?_ga=2.92118746.1754880715.1655770156-1500146562.1655770156"
          target="_blank"
          rel="noopener"
          >{{ $t('Footer.label.legalAndCompliance') }}</a
        >
        |
        <a
          href="https://support.banxa.com/?_ga=2.171768416.1754880715.1655770156-1500146562.1655770156"
          target="_blank"
          rel="noopener"
          >{{ $t('Footer.label.supportCenter') }}</a
        ></span
      >
      <span>
        &copy; {{ currentYear() }} {{ entityDetails.desc }} Trading as Banxa.
      </span>
    </p>
    <p>
      <span>{{ $t('Footer.label.authorised') }}</span>
      <span>{{ entityDetails.prefix }}: {{ entityDetails.address }}</span>
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";
import { useGlobalStore } from "@/stores/globalStore";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const globalStore = useGlobalStore();
const orderStore = useOrderFormStore();

const getEntityObject = (operator) => {
  const opObject = {
    prefix: "",
    desc: "",
    address: "",
  };

  switch (operator) {
    case "riv":
      opObject.prefix = "Registered Office";
      opObject.desc = "Richmond Internet Ventures Corporation";
      opObject.address =
        "Suite 1103 - 11871 Horseshoe Way, Richmond, British Columbia V7A 5H5, Canada";
      break;
    case "eiv":
      opObject.prefix = "Registered Office";
      opObject.desc = "EU Internet Ventures BV";
      opObject.address =
        "Piet Heinkade 93B, 1019GM, Amsterdam, The Netherlands.";
      break;
    default:
      opObject.prefix = "Head Office";
      opObject.desc = "Global Internet Ventures Pty Ltd";
      opObject.address =
        "L2 2-6 Gwynne Street, Cremorne, Victoria 3121, Australia";
      break;
  }

  return opObject;
};

const entityDetails = computed(() => {
  const paymentList = orderStore.getActiveStorePaymentData;
  const selectedPayment = orderStore.getActiveStore.getFormPayload.payment;
  const paymentDetail = paymentList.find((order) => {
    return order.code.toLowerCase() === selectedPayment;
  });
  return getEntityObject(paymentDetail?.operator);
});

const nftLayoutClass = computed(() =>
  orderStore.isNFTMode ? "nft-layout" : ""
);

const currentYear = () => {
  return new Date().getFullYear();
}

const disclaimer = computed(() => {
  // TODO: Add condition for specific merchant
  let geoCheck = false;
  if (globalStore?.getDetectedGeo) {
    geoCheck =
      globalStore?.getDetectedGeo?.country_code?.toUpperCase() === "US";
  }
  return {
    show: geoCheck || true,
    message: t('Footer.label.disclaimer')
  };
});
</script>

<style lang="scss">
.footer {
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  padding: 2.4rem 3.5rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  margin-top: 2rem; //.main-content > div has 2rem

  p {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    span {
      width: 100%;
      @include breakpoint($min-l) {
        width: 50%;

        &:nth-child(even) {
          text-align: right;
        }
      }
    }

    span,
    a {
      color: var(--footer-text-color);
    }

    &.disclaimer {
      color: var(--footer-text-color);
      margin-bottom: 2rem;
    }
  }
}

.footer.nft-layout {
  @include breakpoint($max-sm) {
    display: none;
  }
}
</style>
